import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuPopoverComponent } from '../menu-popover/menu-popover.component';
import { PopoverController } from '@ionic/angular';

export class ResourceSortItem {
  name: string
  action?: () => void
}

@Component({
  selector: 'app-resources-header',
  templateUrl: './resources-header.component.html',
  styleUrls: ['./resources-header.component.scss']
})
export class ResourcesHeaderComponent implements OnInit {

  @Input() title: string = 'unknown'
  @Input() searchPlaceholder: string = ''
  @Input() selectedSortName: string = ''
  @Input() sortItems: ResourceSortItem[] = []
  @Input() showSearch: boolean = true
  @Input() showSort: boolean = true
  @Output() searchTextChanged = new EventEmitter<string>()

  _searchText: string = ''
  get searchText(): string { return this._searchText }
  set searchText(text: string) {
    this._searchText = text;
    this.searchTextChanged.emit(text)
  }

  constructor(private popoverCtrl: PopoverController) { }

  ngOnInit() {
  }

  chooseSortItem(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'resources-popover', event, this.sortItems.map((item: ResourceSortItem) => {
      return { name: item.name, action: () => {
        this.selectedSortName = item.name
        if (item.action) {
          item.action()
        }
      }}
    }))
  }

}
